var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlannedCallsLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.8696,28 L23.7826,28 L23.7826,24.381 L27.9996,24.381 L27.9996,27.87 C27.9996,27.941 27.9416,28 27.8696,28 L27.8696,28 Z M3.9996,27.87 L3.9996,24.381 L8.2176,24.381 L8.2176,28 L4.1306,28 C4.0586,28 3.9996,27.941 3.9996,27.87 L3.9996,27.87 Z M4.1306,6.261 L7.6526,6.261 L7.6526,8.3 C7.6526,8.852 8.0996,9.3 8.6526,9.3 C9.2046,9.3 9.6526,8.852 9.6526,8.3 L9.6526,6.261 L22.3476,6.261 L22.3476,8.3 C22.3476,8.852 22.7956,9.3 23.3476,9.3 C23.8996,9.3 24.3476,8.852 24.3476,8.3 L24.3476,6.261 L27.8696,6.261 C27.9416,6.261 27.9996,6.319 27.9996,6.391 L27.9996,11.145 L3.9996,11.145 L3.9996,6.391 C3.9996,6.319 4.0586,6.261 4.1306,6.261 L4.1306,6.261 Z M23.7826,22.381 L27.9996,22.381 L27.9996,18.763 L23.7826,18.763 L23.7826,22.381 Z M16.9996,22.381 L21.7826,22.381 L21.7826,18.763 L16.9996,18.763 L16.9996,22.381 Z M16.9996,28 L21.7826,28 L21.7826,24.381 L16.9996,24.381 L16.9996,28 Z M10.2166,28 L14.9996,28 L14.9996,24.381 L10.2166,24.381 L10.2166,28 Z M10.2176,22.381 L15.0006,22.381 L15.0006,18.763 L10.2176,18.763 L10.2176,22.381 Z M3.9996,22.381 L8.2166,22.381 L8.2166,18.763 L3.9996,18.763 L3.9996,22.381 Z M4.0006,16.763 L8.2176,16.763 L8.2176,13.144 L4.0006,13.144 L4.0006,16.763 Z M23.7826,16.763 L27.9996,16.763 L27.9996,13.144 L23.7826,13.144 L23.7826,16.763 Z M16.9996,16.763 L21.7826,16.763 L21.7826,13.144 L16.9996,13.144 L16.9996,16.763 Z M10.2166,16.763 L14.9996,16.763 L14.9996,13.144 L10.2166,13.144 L10.2166,16.763 Z M27.8696,4.261 L24.3476,4.261 L24.3476,3 C24.3476,2.448 23.8996,2 23.3476,2 C22.7956,2 22.3476,2.448 22.3476,3 L22.3476,4.261 L9.6526,4.261 L9.6526,3 C9.6526,2.448 9.2046,2 8.6526,2 C8.0996,2 7.6526,2.448 7.6526,3 L7.6526,4.261 L4.1306,4.261 C2.9556,4.261 1.9996,5.216 1.9996,6.391 L1.9996,27.87 C1.9996,29.044 2.9556,30 4.1306,30 L27.8696,30 C29.0446,30 29.9996,29.044 29.9996,27.87 L29.9996,6.391 C29.9996,5.216 29.0446,4.261 27.8696,4.261 L27.8696,4.261 Z",
    id: "path-ec897732-0c06-4239-9876-8c2caa1c66a0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "118.243242%",
    y1: "109.459461%",
    x2: "4.72973324%",
    y2: "6.08107672%",
    id: "linearGradient-ec897732-0c06-4239-9876-8c2caa1c66a0"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Navigation-/-plannedCallsLarge"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-ec897732-0c06-4239-9876-8c2caa1c66a0",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-ec897732-0c06-4239-9876-8c2caa1c66a0"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon-shape",
    fill: "currentColor",
    xlinkHref: "#path-ec897732-0c06-4239-9876-8c2caa1c66a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-color",
    fill: "url(#linearGradient-ec897732-0c06-4239-9876-8c2caa1c66a0)",
    mask: "url(#mask-ec897732-0c06-4239-9876-8c2caa1c66a0)",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlannedCallsLarge);
export default __webpack_public_path__ + "static/media/plannedCallsLarge.3453d4eac90546b061ff59b1a31a471d.svg";
export { ForwardRef as ReactComponent };